import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AppointmentService } from 'src/app/appointment/appointment.service';
import { NewCaseComponent } from '../new-case/new-case.component';
import { ClientListPopupComponent } from '../client-list-popup/client-list-popup.component';
import { NotifierService } from 'angular-notifier';
import { TranslateOrgSpecificPipe } from '../pipes/translate-org-specific.pipe';
import { NavigationExtras, Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-casemanager-case-popup',
  templateUrl: './casemanager-case-popup.component.html',
  styleUrls: ['./casemanager-case-popup.component.css']
})
export class CasemanagerCasePopupComponent implements OnInit {
  participantlist: any[] = [];
  searchText: any;
  selectedCases: any[] = [];
  modalOption: NgbModalOptions = {};
  @Input() public data;
  savedCaseIds = '';
  appoinmentId: any;
  returnIds = '';
  participantId = 0;
  client_selected = false;
  constructor(public activeModal: NgbActiveModal,
    private appointmentService: AppointmentService
    , private modalService: NgbModal
    , private notifier: NotifierService
    , private translateOrgSpecific: TranslateOrgSpecificPipe
    , private router: Router


  ) { }
  appid: number;
  ngOnInit() {

    this.appid = this.data.appointmentId ? this.data.appointmentId : 0;

    this.savedCaseIds = this.data.caseIds ? this.data.caseIds : '';
    this.participantId = this.data.participantId ? this.data.participantId : 0;
    this.getCaseListWithParticipant();

  }
  // closePopup
  closeModal() {
    this.activeModal.close();
    $('#appt-csmg').css('overflow', 'auto');
  }



  getCaseListWithParticipant(type: string = '') {
    this.appointmentService.getCaseListWithParticipant(this.appid).subscribe(
      (data: any) => {
        this.participantlist = data;
        if (this.appid > 0 && this.participantId > 0) {
          this.participantlist = data.filter(obj => (obj.participantId == this.participantId));
        }


        let ids = [];

        if (this.savedCaseIds != '') {
          ids = this.savedCaseIds.split(',');
        }

        if (this.returnIds != '') {
          ids = this.returnIds.split(',');
        }
        if (type == 'callback' || ids.length > 0) {
          this.participantlist.forEach(element => {
            if (this.selectedCases.length > 0) {
              const found = this.selectedCases.find(ele => ele.case_id == element.case_id);
              if (found) {
                element.isHighlight = true;
              }
            }
            if (ids.length > 0) {
              const found = ids.find(ele => ele == element.case_id);

              if (found) {
                element.isHighlight = true;
                const info = this.participantlist.find(ele => ele.case_id == element.case_id);

                this.selectedCases.push(info);
              }
            }
          });
        }
      }
    );
  }

  CardClick(data) {
    let is_sameuserId = false; // ensure selected  cases  are to the  same patient
    const index = this.participantlist.indexOf(data);
    if (this.selectedCases.length > 0) {
      const found = this.selectedCases.find(ele => ele.participantId == data.participantId);
      if (found) {
        is_sameuserId = true;
      } else {
        this.notifier.notify('error', this.translateOrgSpecific.transform('MultipleParticipantSelectError'));
      }
    } else {
      this.selectedCases.push(data);
      this.participantlist[index].isHighlight = true;
    }

    // Return Selected array
    if (is_sameuserId) {
      const selectedCases_index = this.selectedCases.indexOf(data);
      const found = this.selectedCases.find(ele => ele.case_id == data.case_id);
      if (found) {
        this.selectedCases.splice(selectedCases_index, 1);
        this.participantlist[index].isHighlight = false;
      } else {
        this.selectedCases.push(data);
        this.participantlist[index].isHighlight = true;
      }
      // Card select or not(color change)
    }

  }

  newcase() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalOption.size = 'lg';
    if (this.selectedCases.length > 0) {
      this.participantId = this.selectedCases[0].participantId;


      this.client_selected = true;
    } else {
      this.client_selected = false;
    }
    const dialogRef = this.modalService.open(NewCaseComponent, this.modalOption);
    dialogRef.componentInstance.data = { AppoinmentId: this.appid, EditAppoinmentPatientId: this.participantId, clientSelected: this.client_selected };

    dialogRef.result.then((result) => {


      if (result != '' && result != undefined && result != null) {
        this.getCaseListWithParticipant('callback');
        this.returnIds = result;
      }




    });
  }

  CreateAppointment() {
    const caseId: any[] = [];
    this.selectedCases.forEach(ele => {
      caseId.push(ele.case_id);
    });
    const params: NavigationExtras = {
      queryParams: {
        'case-id': caseId.toString()
      }
    };
    this.activeModal.close(caseId.toString());
    if (!this.data.appointmentId) {
      this.router.navigate(['/app/appointment'], params);
    }
  }

}
